import React from 'react';
import {
  Alert,
  Collapse,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

const ModalChangeZone = ({
  onSubmit,
  handleSubmit,
  closePopup,
  severityAlert,
  errorMssge,
  loaderButton,
  zones,
  handleSelectZone,
  zoneValue,
}) => {
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container className='modalBackground'>
        <Grid container size={{ xs: 4 }} className='modalContainer'>
          <Grid container>
            <Grid item size={{ xs: 6 }} className='title'>
              <h3>Cambio de Zona</h3>
            </Grid>
            <Grid item size={{ xs: 6 }} className='titleCloseBtn'>
              <button onClick={closePopup}>
                <CloseIcon />
              </button>
            </Grid>{' '}
          </Grid>
          <Grid container size={{ xs: 12 }} rowSpacing={2}>
            <TextField
              variant='standard'
              select
              fullWidth
              id='select-zone'
              label='Zona'
              value={zoneValue || '9'}
              onChange={handleSelectZone}
            >
              {zones?.map((element) => {
                return (
                  <MenuItem key={element.value} value={element.value}>
                    {element.value}
                  </MenuItem>
                );
              })}
            </TextField>
            <Typography variant='body2' color='textSecondary' sx={{ marginTop: 1 }}>
              EI cambio de numeración telefónica se hace al seleccionar una zona, no se puede
              garantizar la entrega de una numeración especifica, el teléfono resultante incluirá el
              primer número de la zona seleccionada.
            </Typography>
          </Grid>
          <Grid container size={{ xs: 12 }} direction={'column'} rowSpacing={0} textAlign={'start'}>
            <Grid item>
              <h4>NUEVO ZONA : {zoneValue}</h4>
            </Grid>
          </Grid>
          <Grid item size={{ xs: 12 }} paddingTop={2}>
            <Collapse in={errorMssge !== undefined}>
              {errorMssge !== undefined ? (
                <Alert
                  action={
                    <IconButton
                      aria-label='close'
                      color='inherit'
                      size='small'
                      onClick={closePopup}
                    >
                      <CloseIcon fontSize='inherit' />
                    </IconButton>
                  }
                  sx={{ mb: 2 }}
                  severity={severityAlert}
                >
                  {errorMssge}
                </Alert>
              ) : null}
            </Collapse>
          </Grid>
          <Grid item size={{ xs: 12 }} className='footer'>
            <button onClick={closePopup} id='cancelBtn'>
              Cancelar
            </button>

            <LoadingButton
              size='small'
              onClick={onSubmit}
              endIcon={<SendIcon />}
              loading={loaderButton}
              loadingPosition='end'
              variant='contained'
            >
              Cambiar
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>

      {/* Full screen loader */}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.modal + 1,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
        open={loaderButton}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </form>
  );
};

export default ModalChangeZone;
